import { createApp } from 'vue'
import FadeIn from '~/js/components/fadeIn'

const CLASS_NAME_TEIKIBIN_CONCEPT = 'js-teikibin-concept'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinConcept = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_CONCEPT
  )
  if (!elementsTeikibinConcept.length) return

  Array.from(elementsTeikibinConcept).forEach((element) => {
    createApp({
      name: 'SectionsTeikibinConcept',
      components: {
        FadeIn,
      },
    }).mount(element)
  })
})
